module.exports = __webpack_public_path__ + "static/python-9e5efbbdbd66135fb19bd9d1bc0f3476.png";